module.exports = __webpack_public_path__ + "img/product04.907c649a.jpg";